import { ItemConfirm } from "../components/itemConfirm";
import i18n from "@/i18n";

export default class DataOperationError {
    noT_FOUND?:string;
    erroR_SAVING?:string;
    checK_BUSINESS_ERRORS?:string;
    REQUEST_ERROR?:string;
    logginG_ERROR?:string;
    entitY_ERROR?:string;

    static getErrors = (err:DataOperationError):ItemConfirm[] => {
        // Nomme `label` et non `t` : un helper local nomme `t` masque le t() global et
        // fait passer ses arguments pour des cles racines aux yeux de l analyse statique.
        const label = (key:string) => i18n.global.t(`errors.${key}`);
        let itemConfirms:ItemConfirm[] = [];
        if ( err.noT_FOUND != undefined )
            itemConfirms.push({ display: true, title: label("titleNotFound"), progress: true, type: "danger", body: err.noT_FOUND } as ItemConfirm );
        if ( err.erroR_SAVING != undefined )
            itemConfirms.push({ display: true, title: label("titleSaveError"), progress: true, type: "danger", body: err.erroR_SAVING } as ItemConfirm);
        if ( err.checK_BUSINESS_ERRORS != undefined )
            itemConfirms.push({ display: true, title: label("titleBusinessError"), progress: true, type: "warning", body: err.checK_BUSINESS_ERRORS } as ItemConfirm);
        if ( err.REQUEST_ERROR != undefined )
            itemConfirms.push({ display: true, title: label("titleError"), progress: true, type: "danger", body: err.REQUEST_ERROR } as ItemConfirm);
        if ( err.logginG_ERROR != undefined )
            itemConfirms.push({ display: true, title: label("titleError"), progress: true, type: "danger", body: err.logginG_ERROR } as ItemConfirm);
        if ( err.entitY_ERROR != undefined )
            itemConfirms.push({ display: true, title: label("titleError"), progress: true, type: "danger", body: err.entitY_ERROR } as ItemConfirm);
        return itemConfirms;
    }
}
